export enum BookingPageTab {
  All = 'all',
  Today = 'today',
  Tomorrow = 'tomorrow',
  Handling = 'Handling',
}
